/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_DescriptionInputs */

const en_settings_billing_description = /** @type {(inputs: Settings_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your subscriptions`)
};

const zh_settings_billing_description = /** @type {(inputs: Settings_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理你的订阅`)
};

/**
* | output |
* | --- |
* | "Manage your subscriptions" |
*
* @param {Settings_Billing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_description = /** @type {((inputs?: Settings_Billing_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_description(inputs)
	return zh_settings_billing_description(inputs)
});
export { settings_billing_description as "settings.billing.description" }